/**
 * view-item-list-tracking.js
 *
 * Fires GA4 view_item_list events tagged with a placement-specific
 * item_list_id / item_list_name, so product-list impressions can be
 * attributed to which homepage module (or any product list) they came
 * from, instead of one undifferentiated bucket.
 *
 * Markup contract:
 *   Wrapper element: data-view-item-list data-list-id="..." data-list-name="..."
 *   Item elements inside it: data-vil-item data-item-id="..." data-item-name="..." data-item-price="..."
 *
 * A list only fires once per distinct data-list-revision value (default "0"),
 * so a section that swaps its visible product set (e.g. an accordion tab)
 * can trigger a fresh view_item_list by bumping data-list-revision and
 * calling window.fireViewItemList(el) again.
 */
(function () {
  if (window.__vilTrackingInit) return;
  window.__vilTrackingInit = true;

  var firedKeys = new Set();

  function buildItems(listEl) {
    var itemEls = listEl.querySelectorAll('[data-vil-item]');
    var items = [];
    itemEls.forEach(function (el, idx) {
      var priceAttr = el.getAttribute('data-item-price');
      var price = priceAttr !== null ? parseFloat(priceAttr) : undefined;
      items.push({
        item_id: el.getAttribute('data-item-id') || '',
        item_name: el.getAttribute('data-item-name') || '',
        price: isNaN(price) ? undefined : price,
        index: idx,
      });
    });
    return items;
  }

  function fireViewItemList(listEl) {
    if (!listEl) return;
    var listId = listEl.getAttribute('data-list-id');
    if (!listId) return;

    var revision = listEl.getAttribute('data-list-revision') || '0';
    var fireKey = listId + '::' + revision;
    if (firedKeys.has(fireKey)) return;
    firedKeys.add(fireKey);

    if (typeof gtag !== 'function') return;

    var items = buildItems(listEl);
    if (!items.length) return;

    gtag('event', 'view_item_list', {
      item_list_id: listId,
      item_list_name: listEl.getAttribute('data-list-name') || listId,
      items: items,
    });
  }

  window.fireViewItemList = fireViewItemList;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          fireViewItemList(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  function observeAll(root) {
    root.querySelectorAll('[data-view-item-list]').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeAll(document);
    });
  } else {
    observeAll(document);
  }

  // Sections that reveal a new set of products without a full page load
  // (e.g. an accordion tab switch) can call window.fireViewItemList(el)
  // directly after updating data-list-revision, or re-register the element
  // for intersection tracking via this event.
  document.addEventListener('vil:list-revealed', function (e) {
    if (e.detail && e.detail.el) {
      observer.observe(e.detail.el);
    }
  });
})();
